import { BiInfoCircle } from 'react-icons/bi';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
  HStack,
  Link,
  Text,
  TextWithLinks,
  VStack,
} from 'ui_2';

export const EthereumRedemptionInstructions = () => {
  return (
    <Accordion
      type='single'
      collapsible
      defaultValue={'redemptionInstructions'}
      defaultChecked
    >
      <AccordionItem value='redemptionInstructions'>
        <AccordionTrigger>
          <Text font='medium-sm'>How to redeem</Text>
        </AccordionTrigger>
        <AccordionContent>
          <VStack className='gap-2'>
            <ol
              type='1'
              className='marker:font-sm list-decimal space-y-1 pl-5 marker:text-current'
            >
              <li className='text-left'>
                <Text font='sm'>Copy the reward private key.</Text>
              </li>
              <li className='text-left'>
                <Text font='sm'>
                  Open your favorite{' '}
                  <Link href='https://ethereum.org/' target='_blank'>
                    Ethereum
                  </Link>{' '}
                  wallet (Metamask, Trust, Coinbase, etc.)
                </Text>
              </li>
              <li className='text-left'>
                <Text font='sm'>
                  Import account using the reward private key.
                </Text>
              </li>
              <li className='text-left'>
                <Text font='sm'>
                  Transfer the funds to your personal account.
                </Text>
              </li>
            </ol>
            <Text font='sm'>
              You can read more about how Puzzle Arcade giveaways work{' '}
              <Link
                href='https://puzzle.online/blog-detail/introducing-puzzle-raffle'
                target='_blank'
              >
                here
              </Link>
              .
            </Text>
            <Text font='bold-sm'>
              You have 7 days to remove the funds from the provided account. If
              the funds are not removed, they will be added to the next
              giveaway.
            </Text>
          </VStack>
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
};

type Props = {
  redemptionInstructions: string;
  serviceSlug?: string;
};
export const ProductRedemptionInstructions = ({
  redemptionInstructions,
  serviceSlug,
}: Props) => {
  const isGiftKarte = serviceSlug === 'giftkarte';

  return (
    <Accordion
      type='single'
      collapsible
      defaultValue={isGiftKarte ? 'redemptionInstructions' : undefined}
    >
      <AccordionItem value='redemptionInstructions'>
        <AccordionTrigger>
          <Text font='medium-sm'>How to redeem</Text>
        </AccordionTrigger>
        <AccordionContent>
          <HStack className='gap-2'>
            {isGiftKarte && <BiInfoCircle size={20} />}
            <TextWithLinks
              font='sm'
              linkTarget='_blank'
              text={redemptionInstructions}
            />
          </HStack>
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
};
